import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  dashboardData: [],
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboardStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess(state, action) {
      state.dashboardData = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchDashboardFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    resetDashboard(state) {
      state.dashboardData = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  resetDashboard,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
